import CustomSelectField from 'components/forms/customSelectField/CustomSelectField';

interface Props {
  fieldName: string;
  label: React.ReactNode;
  placeholder: string;
  options: { value: string; label: string }[];
  dataTestId?: string;
  leftAddon?: React.ReactNode;
}

const ChannelPolicyField = ({
  fieldName,
  label,
  placeholder,
  options,
  dataTestId,
  leftAddon,
}: Props) => {
  return (
    <CustomSelectField
      label={label}
      labelOnTop
      leftAddon={leftAddon}
      name={fieldName}
      placeholder={placeholder}
      options={options}
      isSearchable={false}
      isClearable
      colSmLabel={12}
      colSmInput={12}
      data-testid={dataTestId}
    />
  );
};

export default ChannelPolicyField;
